const sidebarMenu = [
  {
    path: '/admin/dashboard',
    icon: 'ri-dashboard-line',
    label: 'Dashboard',
    // không permission → ai đăng nhập cũng thấy
  },

  {
    label: 'Quản lý trang chủ',
    icon: 'ri-home-line',
    submenu: [
      {
        path: '/admin/home-management',
        label: 'Banner',
        permission: 'account.manage',
      },
      {
        path: '/admin/home-management/text-blocks',
        label: 'Nội dung nổi bật',
        permission: 'account.manage',
      },
    ],
  },

  {
    label: 'Quản lý khách sạn',
    icon: 'ri-hotel-line',
    submenu: [
      {
        path: '/admin/hotels',
        label: 'Khách sạn',
        permission: 'hotel.manage',
      },
      {
        path: '/admin/hotels/room-type',
        label: 'Loại phòng',
        permission: 'hotel.manage',
      },
      {
        path: '/admin/hotels/rooms',
        label: 'Phòng',
        permission: 'hotel.manage',
      },
    ],
  },

  {
    label: 'Quản lý tin tức',
    icon: 'ri-newspaper-line',
    submenu: [
      {
        path: '/admin/news-categories',
        label: 'Danh mục tin tức',
        permission: 'news.manage',
      },
      {
        path: '/admin/news',
        label: 'Tin tức',
        permission: 'news.manage',
      },
    ],
  },

  {
    path: '/admin/contacts',
    icon: 'ri-contacts-line',
    label: 'Quản lý liên hệ',
    permission: 'contact.manage',
  },

  {
    path: '/admin/contact-info',
    icon: 'ri-contacts-line',
    label: 'Liên hệ & địa chỉ khách sạn',
    permission: 'hotel.contact.edit',
  },

  {
    path: '/admin/permission',
    icon: 'ri-shield-keyhole-line',
    label: 'Quyền truy cập hệ thống',
    adminOnly: true, // 🔥 chỉ admin
  },

  {
    path: '/admin/profile',
    icon: 'ri-user-line',
    label: 'Tài khoản',
    // ai đăng nhập cũng xem được
  },
];

export { sidebarMenu };
